module.exports = __webpack_public_path__ + "static/media/arrow-right.1b5a9066.svg";